module.exports = __webpack_public_path__ + "img/derHut.2be39074.svg";